import {createFileRoute} from '@tanstack/react-router'
import KotcView from "../../../kotc/KotcView.tsx";

export const Route = createFileRoute('/_app/kotc/$kotc_uid/$page')({
    component: RouteComponent,
})

function RouteComponent() {
    return <KotcView />
}
